import actionTypes from './action-types';
import socketService from '../services/socket.service';
import cryptoService from '../services/crypto.service';

export function receiveExpenses(expenses, error?, month?, year?) {
  return {
    type: actionTypes.RECEIVE_EXPENSES,
    expenses:
      expenses &&
      expenses.reduce((acc, value) => {
        value.value = Number(cryptoService.decrypt(value.value));
        acc[value._id] = value;
        return acc;
      }, {}),
    error,
    month,
    year
  };
}

export function removeMonths() {
  return {
    type: actionTypes.REMOVE_MONTHS
  };
}

export function fetchExpenses(month = new Date().getMonth()) {
  return async (dispatch, getState) => {
    let date = new Date();
    let firstDay = new Date(date.getFullYear(), month, 1);
    if (
      getState().months[month] !== undefined ||
      getState().years[new Date().getFullYear() - firstDay.getFullYear()] != undefined
    ) {
      return;
    }
    let lastDay = new Date(date.getFullYear(), month + 1, 1);
    const expenses = await socketService.emit('expensesList', { start: firstDay.getTime(), end: lastDay.getTime() });
    dispatch(receiveExpenses(expenses, null, month));
  };
}

export function fetchYearlyExpenses(year = new Date().getFullYear()) {
  return async (dispatch, getState) => {
    if (getState().years[year] !== undefined) {
      return;
    }
    let date = new Date();
    let firstDay = new Date(date.getFullYear() + year, 0, 1);
    let lastDay = new Date(date.getFullYear() + year + 1, 0, 1);
    const expenses = await socketService.emit('expensesList', { start: firstDay.getTime(), end: lastDay.getTime() });
    dispatch(receiveExpenses(expenses, null, null, year));
  };
}

export function fetchExpense(_id) {
  return async (dispatch, getState) => {
    if (getState().expenses[_id]) {
      return;
    }
    const expense = await socketService.emit('expenses', { _id });
    dispatch(receiveExpenses([expense]));
  };
}

export function updateExpense(expense) {
  return async (dispatch) => {
    try {
      expense.value = cryptoService.encrypt(expense.value);
      const saved = await socketService.emit(expense._id ? 'expensesUpdate' : 'expensesAdd', expense);
      dispatch(receiveExpenses([saved]));
    } catch (e) {
      dispatch(receiveExpenses(null, e.message));
    }
  };
}

export function deletedExpense({ _id }) {
  return {
    type: actionTypes.DELETED_EXPENSE,
    _id
  };
}

export function deleteExpense(_id) {
  return async (dispatch) => {
    const expense = await socketService.emit('expensesDelete', { _id });
    dispatch(deletedExpense(expense));
  };
}

export async function fetchDescriptions(description) {
  const expenses = await socketService.emit('descriptionAutoComplete', description);
  const results = receiveExpenses(expenses).expenses;
  return Object.keys(results).map((k) => results[k]);
}

export async function searchExpenses(terms, year?, month?) {
  const expenses = await socketService.emit('expensesSearch', { terms, year, month });
  const results = receiveExpenses(expenses).expenses;
  return Object.keys(results).map((k) => results[k]);
}



// WEBPACK FOOTER //
// ./src/actions/expenses.ts